export enum HPSobBusinessUnits {
  JBPPC = 'jbp-pc',
  JBPPrint = 'jbp-print',
  JBPSupplies = 'jbp-supplies',
}
